<template>
  <el-dialog
    title="问题反馈回复"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >

    <el-form
            ref="form"
            :model="form"
            label-width="100px"
            size="small"
    >
      <el-form-item
              label="用户反馈意见"
      >
        {{deposit_type}}
      </el-form-item>
      <el-form-item
              label="平台回复内容"
      >
        <div class="text-area">
      <textarea  v-model="form.reply_content"  placeholder="请输入回复意见...">

      </textarea>
        </div>

      </el-form-item>
      <el-form-item label="图片" prop="reply_url"  >
        <el-input v-model="form.reply_url" style="display:none"></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=1
                :auto-upload="true"
                :file-list="fileList"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemove"
                :on-success="handlePictureCardPreview">
          <i class="el-icon-plus"></i>
        </el-upload>
        建议尺寸1000*600像素，大小1M以内，支持jpg、png、jpeg格式
      </el-form-item>
      <el-form-item>
      <el-button
              type="primary"
              :loading="loading"
              @click="saveUser"
      >保存</el-button>
      <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<style>

  .bg-purple-dark {
    background: #e5e9f2;
  }
</style>
<script>
import * as agentService from '@/api/sys/agent'
import * as userService from '@/api/sys/user'
import util from '@/libs/util.js'
export default {
  name: 'payconfigureEditForm',
  props: {
    agent: Object,
    accuseVisible: Boolean,
    value: Boolean
  },
  data () {
    return {
      imgUrl: process.env.VUE_APP_API + '/moblieapp/currencyUpload',
      accuseVisible2: true,
      loading: false,
      deposit_type: '',
      dialogVisible: false,
      fileList: [],
      form: {
        deposit_type2: '收银'
      }
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    accuseVisible (newValue, oldValue) {
      console.log('-----' + newValue)
      this.accuseVisible2 = newValue
    },
    handleClick () {

    },
    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    dialogOpen () {
      this.$refs.form.resetFields()
      this.deposit_type = this.agent.content
    },

    // 上传文件之前的钩子
    handleBeforeUpload (file) {
      let isJPG = true
      // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
      console.log('before')
      if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        isJPG = false
        this.$notify.warning({
          title: '警告',
          message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
        })
      }
      let size = file.size / 1024 / 1024 / 2
      if (size > 2) {
        this.$notify.warning({
          title: '警告',
          message: '图片大小必须小于2M'
        })
        isJPG = false
      }

      return isJPG // 返回false不会自动上传
    },

    // 文件列表移除文件时的钩子
    handleRemove (file, fileList) {
      this.form.reply_url = ''
      this.dialogVisible = true
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview (file) {
      console.log('url===' + file.url)
      this.form.reply_url = file.url
      this.dialogVisible = true
    },
    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.agent.id) {
            this.loading = true
            agentService.saveAgentReply({ ...this.form, id: this.agent.id })
              .then(data => {
                this.loading = false
                this.dialogVisible = false
                this.$emit('submit')
              })
          }
        } else {
          return false
        }
      })
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
  /*文本域*/
  .text-area{
    width: 90%;
    border-top:1px solid gainsboro;
    border-bottom:1px solid gainsboro;

  }
  .text-area textarea {
    width: 90%;
    margin: 0.75rem  0;
    border: none;
    outline: none;
    padding-left: 1.125rem;
    height: 6.5rem ;
  }

  .text-area textarea::-webkit-input-placeholder {
    color: #9E9E9E;

  }

</style>
